"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACK = void 0;
const GenericValidator_1 = require("./GenericValidator");
const moment = require("moment");
const validator_1 = require("validator");
const contains = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.contains(value, config.seed), `Value '%s' does not contains '${config.seed}'`);
const isAfter = (config) => new GenericValidator_1.GenericValidator(config, (value) => {
    const date = moment(value, config.format || 'DD/MM/YYYY');
    const referenceDate = config.date
        ? moment(config.date, config.format || 'DD/MM/YYYY')
        : moment();
    return date.isAfter(referenceDate);
}, `Date at '%s' is not after '${config.date || new Date()}'`);
const isAlpha = (config) => new GenericValidator_1.GenericValidator(config, 
// tslint:disable-next-line:no-any
(value) => validator_1.default.isAlpha(value, config.locale), "Value '%s' is not alpha'");
const isAlphaNumeric = (config) => new GenericValidator_1.GenericValidator(config, 
// tslint:disable-next-line:no-any
(value) => validator_1.default.isAlphanumeric(value, config.locale), "Value '%s' is not alphanumeric'");
const isAscii = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isAscii(value), "Value '%s' is not ascii'");
const isBase32 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isBase32(value), "Value '%s' is not BASE32'");
const isBase64 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isBase64(value), "Value '%s' is not BASE64'");
const isBefore = (config) => new GenericValidator_1.GenericValidator(config, (value) => {
    const date = moment(value, config.format || 'DD/MM/YYYY');
    const referenceDate = config.date
        ? moment(config.date, config.format || 'DD/MM/YYYY')
        : moment();
    return date.isBefore(referenceDate);
}, `Date at '%s' is not before '${config.date || new Date()}'`);
const isBIC = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isBIC(value), "Value '%s' is not a valid BIC or SWIFT code");
const isBoolean = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isBoolean(value), "Value '%s' is not a boolean");
const isCreditCard = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isCreditCard(value), "Value '%s' is not a valid credit card number");
const isDataURI = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isDataURI(value), "Value '%s' is not a valid data URI");
const isDecimal = (config) => new GenericValidator_1.GenericValidator(config, 
// tslint:disable-next-line:no-any
(value) => validator_1.default.isDecimal(value, {
    locale: config.locale,
}), "Value '%s' is not a decimal number");
const isDivisibleBy = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isDivisibleBy(value, config.number), `Value '%s' is not divisible by ${config.number}`);
const isEmail = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isEmail(value), "Value '%s' is not a valid email address");
const isFQDN = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isFQDN(value), "Value '%s' is not a valid FQDN");
const isHash = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isHash(value, (config.algorithm || 'sha1')), `Value '%s' is not a valid ${config.algorithm || 'sha1'} hash`);
const isHexadecimal = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isHexadecimal(value), "Value '%s' is not a valid hexadecimal string");
const isHexColor = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isHexColor(value), "Value '%s' is not a valid hex color string");
const isIn = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isIn(value, config.values.split(',')), `Value '%s' is not in ${config.values}`);
const isInt = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isInt(value), "Value '%s' is not an int");
const isIP = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isIP(value, config.version), "Value '%s' is not a valid IP address");
const isIPRange = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isIPRange(value), "Value '%s' is not a valid IP Range");
const isISBN = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISBN(value, config.version), "Value '%s' is not a valid ISBN");
const isISIN = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISIN(value), "Value '%s' is not a valid ISIN");
const isISO31661Alpha2 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISO31661Alpha2(value), "Value '%s' is not a valid ISO 3166-1 alpha-2 string");
const isISO31661Alpha3 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISO31661Alpha3(value), "Value '%s' is not a valid ISO 3166-1 alpha-3 string");
const isISO8601 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISO8601(value), "Value '%s' is not a valid ISO 8601 string");
const isISSN = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISSN(value), "Value '%s' is not a valid ISSN");
const isISRC = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isISRC(value), "Value '%s' is not a valid ISRC");
const isRFC3339 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isRFC3339(value), "Value '%s' is not a valid RFC 3339 date");
const isJSON = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isJSON(value), "Value '%s' is not a valid JSON string");
const isJWT = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isJWT(value), "Value '%s' is not a valid JWT token string");
const isLatLong = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isLatLong(value), "Value '%s' is not a valid latitude-longitude string");
const isMACAddress = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isMACAddress(value), "Value '%s' is not a valid MAC Address");
const isMagnetURI = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isMagnetURI(value), "Value '%s' is not a valid magnet uri");
const isMD5 = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isMD5(value), "Value '%s' is not a valid MD5");
const isMimeType = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isMimeType(value), "Value '%s' is not a valid mime type");
const isMongoId = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isMongoId(value), "Value '%s' is not a valid mongo object id");
const isNumeric = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isNumeric(value), "Value '%s' is not a valid numeric string");
const isOctal = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isOctal(value), "Value '%s' is not a valid octal string");
const isPort = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isPort(value), "Value '%s' is not a valid port number");
const isUUID = (config) => new GenericValidator_1.GenericValidator(config, (value) => validator_1.default.isUUID(value, config.version || 'all'), "Value '%s' is not a valid UUID");
const matches = (config) => new GenericValidator_1.GenericValidator(config, (value) => {
    const ret = validator_1.default.matches(value, config.pattern);
    return ret;
}, `Value '%s' does not match '${config.pattern}'`);
exports.PACK = {
    contains,
    isAfter,
    isAlpha,
    isAlphaNumeric,
    isAscii,
    isBase32,
    isBase64,
    isBefore,
    isBIC,
    isBoolean,
    isCreditCard,
    isDataURI,
    isDecimal,
    isDivisibleBy,
    isEmail,
    isFQDN,
    isHash,
    isHexadecimal,
    isHexColor,
    isIn,
    isInt,
    isIP,
    isIPRange,
    isISBN,
    isISIN,
    isISO8601,
    isISO31661Alpha2,
    isISO31661Alpha3,
    isISRC,
    isISSN,
    isJSON,
    isJWT,
    isLatLong,
    isMACAddress,
    isMagnetURI,
    isMD5,
    isMimeType,
    isMongoId,
    isNumeric,
    isOctal,
    isPort,
    isRFC3339,
    isUUID,
    matches,
};
//# sourceMappingURL=SimpleRulePack.js.map